module.exports = __webpack_public_path__ + "static/media/Sterling Bank Plc Logo.16bc1686.svg";